import { Link } from "react-router";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { WorkspaceGroup } from "@/types/workspaces";

interface GroupListProps {
  groups: WorkspaceGroup[];
}

function GroupList({ groups }: GroupListProps) {
  return (
    <div className="w-60 max-w-full">
      {groups.map((group, i) => (
        <div key={`group-${group.id}`} className={i > 0 ? "mt-3" : ""}>
          <Link to={`/workspace/groups/${group.id}`}>{group.name}</Link>
        </div>
      ))}
    </div>
  );
}

export function GroupsWithPopover({ groups }: { groups: WorkspaceGroup[] }) {
  if (!groups || groups.length === 0) {
    return <div className="italic text-muted-foreground">No groups</div>;
  }
  if (groups.length == 1) {
    return (
      <Link to={`/workspace/groups/${groups[0].id}`}>{groups[0].name}</Link>
    );
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="flex items-center w-fit border-b border-dashed border-muted-foreground cursor-help break-words py-1">
          {groups.length} groups
        </div>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto">
        <GroupList groups={groups} />
      </PopoverContent>
    </Popover>
  );
}
